module.exports = __webpack_public_path__ + "media/images/lane/waiter-apps-0bc94ed83b25a201e9ce899b0a2c1e66.svg";